export const verifyInformationTranslationObject = {
  content: {
    'SELFBILL.MODAL.HEADER': 'Verify Information',
    'SELFBILL.MODAL.NOTICE':
      "We need to verify some information to ensure you can continue using the platform seamlessly. If you're seeing this form again, it means there was an issue with the information you provided previously. Please double-check your details and resubmit.",
    'SELFBILL.MODAL.AGREEMENT': 'I agree to opt in to self-billing.',
    'SELFBILL.MODAL.TERMS': 'Full terms and conditions',
    'REGISTER.DETAILS.LABEL.COUNTRY': 'Country*',
    'REGISTER.DETAILS.LABEL.ADDRESS1': 'Address Line 1*',
    'REGISTER.DETAILS.LABEL.ADDRESS2': 'Address Line 2',
    'REGISTER.DETAILS.LABEL.CITY': 'City*',
    'REGISTER.DETAILS.LABEL.POSTCODE': 'Postal Code*',
    'PROFILE.TAX_INFORMATION.VAT': 'Are you VAT registered?',
    'PROFILE.TAX_INFORMATION.VAT_NUMBER': 'VAT Number:',
    'PROFILE.TAX_INFORMATION.LLC': 'Are you working via a limited company?',
    'PROFILE.TAX_INFORMATION.LLC_NAME': 'Company Name:',
    'PROFILE.TAX_INFORMATION.LLC_NUMBER': 'Company Number:',
    'PROFILE.TAX_INFORMATION.RECEIVE_VAT':
      'Do you want to receive VAT for your services?',
    'APP.NAV.LOGOUT': 'Log Out',
    'GENERIC.SUBMIT': 'Submit',
  },
};
